import React from 'react';
import { Download, Star } from 'lucide-react';
import { useEffect, useState, useCallback } from 'react';
import { ApiConfig } from '../Api/ApiConfig';
import { simpleGetCallWithErrorResponse } from '../Api/ApiServices';
import { useParams } from 'react-router-dom';
import { useContext } from 'react';
import { AppContext } from '../context/AppContext';
import { toastMsg } from '../component/toast';
import { formatDate, formatToDDMMYYYY } from '../common';
import PersonalityDetails from '../component/personalityDeatils';
import FileSaver from 'file-saver';

/**
 * CandidateReport Component
 * Recreates the LYWO Candidate Summary Report in React using Lywo Enterprise Styles.
 * Integrated with lywo-styles (1).css tokens.
 * Footer removed for screen view.
 */


const DisplayProfile = ({ title = "", profile = {}, candidate, handlePersonality, percentage }) => {

    return (
        <div className="mb-2" >
            <h4 className="text-primary mb-2"
                onClick={() => profile?.profileName &&  handlePersonality(profile?.profileName, true)}
            >{title} :  {profile?.profileName} ({percentage || 'N/A'})</h4>
            <p className="fst-italic text-muted mb-2 text-base lh-sm">{profile?.shortDescriptions}</p>
            
            <div className="table-container mb-0">
                <table className="ant-table">
                    <tbody>


                        <tr>
                            <td className="attr-col">Strength</td>
                            <td>{profile?.strengths || "N/A"}</td>
                        </tr>
                        <tr>
                            <td className="attr-col">Uniqueness</td>
                            <td>{profile?.theirUniqueness|| "N/A"}</td>
                        </tr>
                        <tr>
                            <td className="attr-col">Value To Org.</td>
                            <td>{profile?.valueToOrganization|| "N/A"}</td>
                        </tr>
                        <tr>
                            <td className="attr-col">Challenges</td>
                            <td>{profile?.challenges|| "N/A"}</td>
                        </tr>
                        <tr>
                            <td className="attr-col">Motivation</td>
                            <td>{profile?.motivations|| "N/A"}</td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    )

}

export default function CandidateSummary1() {


    const { code, userId } = useParams();
    const { adminData } = useContext(AppContext);
    const [personalityDetails, setPersonalityDetails] = useState({ isOpen: false, per: "" });
    const [isLoading, setIsLoading] = useState(false);
    const [candidate, setCandidate] = useState({});



    useEffect(() => {



        getSummary();
    }, []);


    const handlePersonality = useCallback((per, isOpen) => {
        setPersonalityDetails({ isOpen: isOpen, per: per });
    }, []);




    const getSummary = () => {
        setIsLoading(true);
        simpleGetCallWithErrorResponse(ApiConfig.GET_SUMMARY_REPORT + `UserId=${userId}&Code=${code}&Admin=${adminData?.email}`).then((res) => {
            if (res?.json?.succeded) {
                setCandidate(res?.json?.response);
                

                document.title = res?.json?.response?.candidateName + " - Candidate Summary";

            }
            setIsLoading(false);
        });
    };

    const downloadSummaryReport = () => {
        simpleGetCallWithErrorResponse(ApiConfig.DOWNLOAD_SUMMARY_REPORT + `?code=${code}&userId=${userId}`).then((res) => {
            if (res?.json?.succeded) {
                FileSaver.saveAs(
                    `data:application/pdf;base64,${res?.json?.response?.pdfBase64}`,
                    candidate?.candidateName + '_Summary_Report.pdf'
                );
            }
        })
    }


    return (
        <div className="ds-wrapper pt-5 pb-5 px-3">
            <style>{`
        @import url("https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css");
        @import url("https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap");


        :root {
          --color-blue-500: #081DA5;
          --color-indigo-100: #eef2ff;
          --color-green-100: #d1e7dd;
          --color-green-700: #198754;
          --color-yellow-100: #fff3cd;
          --color-yellow-700: #856404;
          --color-red-100: #f8d7da;
          --color-red-700: #dc3545;
          --color-gray-50: #f5f8ff;
          --color-gray-100: #F2F4F7;
          --color-gray-200: #d0d5dd;
          --color-gray-700: #667085;
          --color-gray-800: #344054;
          --color-gray-900: #212529;


          --brand-primary: var(--color-blue-500);
          --brand-bg: var(--color-gray-50);
          --brand-text: var(--color-gray-900);
          --color-info-bg: var(--color-indigo-100);
          --color-success-bg: var(--color-green-100);
          --color-success-text: var(--color-green-700);
          --color-danger-bg: var(--color-red-100);
          --color-danger-text: var(--color-red-700);
          --ui-gray-bg: var(--color-gray-100);
          --ui-border: var(--color-gray-200);
          --ui-text-muted: var(--color-gray-700);
          --ui-text-dark: var(--color-gray-800);


          --radius-md: 0.5rem;
          --radius-lg: 0.75rem;


          --type-ratio: 1.125;
          --font-size-base: 0.6875rem; /* ~11px */
          --font-size-sm: calc(var(--font-size-base) / var(--type-ratio));
          --font-size-h4: calc(var(--font-size-base) * var(--type-ratio) * var(--type-ratio));
          --font-size-h3: 1.125rem;
          --font-size-h2: 1.5rem;
          --font-size-h1: 1.875rem;


          --line-height-heading: 1.14;
          --line-height-body: 1.4;
          --line-height-sm: 1.5;
        }


        body { font-family: 'Inter', sans-serif !important; background-color: #525659; font-size: var(--font-size-base); }
        .ds-wrapper { align-items: center; }


        /* Report Paper Container */
        .report-paper {
          background-color: white;
          width: 100%;
          max-width: 800px;
          padding: 40px;
          border-radius: 4px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.2);
          color: var(--brand-text);
        }


        /* Typography */
        h1, .h1 { font-size: var(--font-size-h1) !important; font-weight: 700; color: var(--brand-primary); margin-bottom: 0.25rem; }
        h3, .h3 { font-size: var(--font-size-h3) !important; font-weight: 700; padding-bottom: 6px; margin-bottom: 6px; }
        h4, .h4 { font-size: var(--font-size-h4) !important; font-weight: 700; margin-bottom: 0.25rem; }


        /* Tables (Ant Table Style) */
        .table-container { border: 1px solid var(--ui-border); border-radius: 8px; overflow: hidden; background: #fff; margin-bottom: 1.5rem; }
        .ant-table { width: 100%; border-collapse: collapse; }
        .ant-table th { background: #fafafa; padding: 8px 12px; text-align: left; font-weight: 700; font-size: var(--font-size-base); border-bottom: 1px solid var(--ui-border); }
        .ant-table td { padding: 8px 12px; font-size: var(--font-size-base); color: var(--ui-text-dark); border-bottom: 1px solid var(--ui-border); vertical-align: top; }
        .ant-table tr:last-child td { border-bottom: none; }
        .ant-table .attr-col { width: 25%; font-weight: bold; color: var(--brand-text); background: #fafafa; border-right: 1px solid var(--ui-border); }


        /* Badges */
        .badge { display: inline-flex; align-items: center; padding: 0.25em 0.75em; border-radius: 9999px; font-size: var(--font-size-sm); font-weight: 600; line-height: 1; border: 1px solid transparent; }
        .badge-excellent { background-color: var(--color-success-bg); color: var(--color-success-text); border-color: var(--color-success-bg); }
        .badge-poor { background-color: var(--color-danger-bg); color: var(--color-danger-text); border-color: var(--color-danger-bg); }


        /* Dashboard Grid */
        .dashboard-grid {
          display: grid;
          grid-template-columns: repeat(6, 1fr);
          border: 1px solid var(--ui-border);
          border-radius: 8px;
          overflow: hidden;
          margin-bottom: 1.5rem;
        }
        .dash-cell { padding: 10px 4px; text-align: center; border-right: 1px solid var(--ui-border); }
        .dash-cell:last-child { border-right: none; }
        .dash-label { font-size: var(--font-size-sm); color: var(--ui-text-muted); font-weight: bold; display: block; margin-bottom: 4px; }
        .dash-value { font-weight: bold; font-size: var(--font-size-base); }


        /* Resume Highlights Box */
        .hl-box { border: 1px solid #0d6efd; background-color: var(--brand-bg); border-radius: 8px; overflow: hidden; margin-bottom: 1.5rem; }
        .hl-header { font-size: var(--font-size-h4); font-weight: 700; color: var(--brand-primary); padding: 8px 12px; border-bottom: 1px solid #0d6efd; background-color: rgba(13, 110, 253, 0.05); }
        .hl-content { padding: 10px 12px; }
        .hl-item { display: flex; align-items: flex-start; margin-bottom: 6px; font-size: var(--font-size-base); line-height: 1.4; }
        .hl-item:last-child { margin-bottom: 0; }
        .hl-bullet { color: #0d6efd; margin-right: 8px; margin-top: 1px; }


        /* Lywo Button Style */
     

        /* Media Print */
        @media print {
          body { background-color: white; padding: 0; }
          .report-paper { box-shadow: none; margin: 0; max-width: none; padding: 0; }
          /* Hide internal buttons in PDF output */
          [data-html2canvas-ignore="true"] { display: none !important; }
        }
      `}</style>


            {/* Main Report Document */}
            <div className="report-paper">
                {/* HEADER */}
                <div className="row g-0 pb-1 ">
                    <div className="col-7">
                        <h1 className='text-primary'>{candidate?.candidateName}</h1>
                        <h4 className="text-muted">{candidate?.currentJobTitle}</h4>
                        <div className="fw-medium text-muted mt-2">{candidate?.mobile} | {candidate?.email}</div>
                    </div>
                    <div className="col-5 d-flex flex-column align-items-end justify-content-start">
                        <button
                            className="btn btn-primary shadow-sm"
                            onClick={downloadSummaryReport}
                            data-html2canvas-ignore="true"
                        >
                            <Download size={14} /> Download PDF
                        </button>
                        <h4 className="text-end">
                            <span className="fw-medium text-muted" style={{ fontSize: 'var(--font-size-sm)' }}>Applied For</span>
                            <br />
                            {candidate?.forPosition}
                        </h4><div className="text-primary fw-bold">{candidate?.forCompany}</div>
                    </div>
                </div>


                {/* DASHBOARD GRID */}
                <div className="dashboard-grid">

                    <div className="dash-cell">
                        <span className="dash-label">Location</span>
                        <span className={`dash-value `}>
                            {/* ${stat.status === 'excellent' ? 'text-success' : ''} */}
                            {candidate?.currentLocation}
                        </span>
                    </div>
                    <div className="dash-cell">
                        <span className="dash-label">Assessment </span>
                        <span className={`dash-value `} style={{color:candidate?.technicalScore!="N/A"?'var(--color-success-text)':''}}>
                            {candidate?.technicalScore}
                        </span>
                    </div>
                    <div className="dash-cell">
                        <span className="dash-label">Experience </span>
                        <span className={`dash-value `}>
                            {candidate?.yearsOfExperience ||'N/A'} {candidate?.yearsOfExperience ? "Years" : ""}
                        </span>
                    </div>
                    <div className="dash-cell">
                        <span className="dash-label">Availability </span>
                        <span className={`dash-value `}>
                            { candidate?.availableBy? formatToDDMMYYYY(candidate?.availableBy):"N/A"}
                        </span>
                    </div>
                    <div className="dash-cell">
                        <span className="dash-label" style={{ width: '160px' }}>Expected Salary </span>
                        <span className={`dash-value `}>
                            {candidate?.expectedSalary || "N/A"}
                        </span>
                    </div>
                    <div className="dash-cell">
                        <span className="dash-label">BuyOut </span>
                        <span className={`dash-value `}>
                            {candidate?.buyOutOption ? 'Yes' : "No"}
                        </span>
                    </div>

                </div>

                <div className='mb-4'>
                    <h3>Applicant Basic Info</h3>
                     <div className="table-container mb-0">
                <table className="ant-table">
                    <tbody>


                        <tr>
                            <td className="attr-col">Current Title</td>
                            <td>{candidate?.currentJobTitle || "N/A"}</td>
                        </tr>
                        <tr>
                            <td className="attr-col">Current Company</td>
                            <td>{candidate?.currentCompany || "N/A"}</td>
                        </tr>
                        <tr>
                            <td className="attr-col">Current Industry</td>
                            <td>{candidate?.currentIndustry || 'N/A'}</td>
                        </tr>
                        <tr>
                            <td className="attr-col">Department</td>
                            <td>{candidate?.currentDepartment || "N/A"}</td>
                        </tr>
                        <tr>
                            <td className="attr-col">Education Level</td>
                            <td>{candidate?.educationLevel || "N/A"}</td>
                        </tr>
                         <tr>
                            <td className="attr-col">Education Area</td>
                            <td>{candidate?.educationalArea || "N/A"}</td>
                        </tr>
                         <tr>
                            <td className="attr-col">Current Salary</td>
                            <td>{candidate?.currentSalary || 'N/A'}</td>
                           
                        </tr>

                    </tbody>
                </table>
            </div>
                </div>
                {/* CUSTOM QUESTIONS */}
                <section>
                    <h3>Custom Questions</h3>
                    <div className="table-container shadow-sm">
                        {
                            candidate?.customQuestions?.length > 0 ?

                                <table className="ant-table">
                                    <tbody>
                                        {candidate?.customQuestions?.map((q, i) => (
                                            <tr key={i}>
                                                <td className="w-75">{q?.questionText}</td>
                                                <td className="text-end">
                                                    <span className={`badge badge-${candidate[`ans${i + 1}`] == "Yes" ? 'excellent' : 'poor'}`}>{candidate[`ans${i + 1}`] || "N/A"}</span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table> :
                                <div className="text-base text-slate-medium " style={{ padding: '0.2rem' }}>Not Available</div>
                        }
                    </div>
                </section>


                {/* WORK HISTORY */}
                <section>
                    
                    <h3>Work History</h3>
                    <div className="ps-2">
                        {candidate?.resumeMatch && candidate?.resumeMatch[0]?.workHistoryDetails && candidate?.resumeMatch &&
                            candidate?.resumeMatch[0]?.workHistoryDetails ? candidate?.resumeMatch && candidate?.resumeMatch[0]?.workHistoryDetails?.map((job, i) => (
                                <div className="mb-3 pb-3 border-bottom" key={i} style={{ lastChild: { borderBottom: 'none' } }}>
                                    <div className="d-flex justify-content-between mb-1">
                                        <span className="fw-bold h4 m-0">
                                            {job.position} <span className="fw-normal text-muted">@ {job.company}</span>
                                        </span>
                                        <span className="fst-italic fw-bold text-muted">{job.duration}</span>
                                    </div>
                                    <div className="text-dark">{job.focus}</div>
                                </div>
                            )) : <div className="text-base text-slate-medium mb-2" >Not Available</div>}
                    </div>
                </section>


                {/* EDUCATION */}
                <section>
                    <h3>Education</h3>
                    {
                        candidate?.resumeMatch && candidate?.resumeMatch[0]?.resumeEducationDetails?.length>0?
                    <div className="table-container shadow-sm">
                        <table className="ant-table">
                            <thead>
                                <tr>
                                    <th width="35%">Education Level</th>
                                    <th width="45%">Institution</th>
                                    <th width="20%" className="text-end">Year</th>
                                </tr>
                            </thead>
                            <tbody>
                                {candidate?.resumeMatch && candidate?.resumeMatch[0]?.resumeEducationDetails?.map((edu, i) => (
                                    <tr key={i}>
                                        <td className="fw-bold text-primary">{edu?.qualification || edu?.educationType ||'N/A'}</td>
                                        <td>{edu.institution ||'N/A'}</td>
                                        <td className="text-end text-muted fw-bold">{edu.completionYear||'N/A'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    :
                    <div className="text-base text-slate-medium" style={{ padding: '0.2rem',marginTop:'-5px' }}>Not Available</div>
                }
                </section>


                {/* PERSONALITY GROUPS */}
                <section>
                    <h3>Candidate Personality Groups</h3>
                    <DisplayProfile
                        handlePersonality={handlePersonality}
                        percentage={candidate?.primaryProfilePercent}
                        title={candidate?.primaryProfile?.profileName == candidate?.secondaryProfile?.profileName ? "Primary & Secondary" : "Primary"}
                        profile={candidate?.primaryProfile || {}} candidate={candidate || {}} />
                    {
                        candidate?.primaryProfile?.profileName != candidate?.secondaryProfile?.profileName &&
                        <DisplayProfile title={"Secondary"} profile={candidate?.secondaryProfile || {}} candidate={candidate || {}}
                            handlePersonality={handlePersonality}
                            percentage={candidate?.secondaryProfilePercent}
                        />

                    }



                </section>


                {/* RESUME HIGHLIGHTS */}
                <section>
                    <div className="hl-box shadow-sm">
                        <div className="hl-header text-primary">Resume Highlights</div>
                        <div className="hl-content">
                            {
                            candidate?.resumeMatch && candidate?.resumeMatch[0]?.matchDetails?
                            candidate?.resumeMatch && candidate?.resumeMatch[0]?.matchDetails?.map((h, i) => (
                                <div className="hl-item" key={i}>
                                    <Star size={10} className="hl-bullet" fill="currentColor"
                                        style={{
                                            marginTop: '3px',
                                            minWidth: '10px',   // prevent shrinking
                                            minHeight: '10px',
                                            flexShrink: 0       // stop flex from resizing it
                                        }}
                                    />
                                    <div>{h?.description}</div>
                                </div>
                            ))
                        :"N/A"
                        }
                        </div>
                    </div>
                </section>

                <section>
                    <div className="hl-box shadow-sm">
                        <div className="hl-header text-primary">Watch Out For</div>
                        <div className="hl-content">

                            {candidate?.resumeMatch && candidate?.resumeMatch[0]?.watchOutFor?.length > 0 ? candidate?.resumeMatch[0]?.watchOutFor?.map((h, i) => (
                                <div className="hl-item" key={i}>
                                    <Star size={10} className="hl-bullet" fill="currentColor"
                                        style={{
                                            marginTop: '3px',
                                            minWidth: '10px',   // prevent shrinking
                                            minHeight: '10px',
                                            flexShrink: 0       // stop flex from resizing it
                                        }}
                                    />
                                    <div>{h?.description}</div>
                                </div>
                            )) : <div className="text-base text-slate-medium" >N/A</div>}
                        </div>
                    </div>
                </section>


                {/* COLLABORATOR NOTES */}
                <section>
                    <h3>Collaborator Notes</h3>

                    <div className="table-container shadow-sm">

                        {
                            candidate?.adminNotes?.length == 0 || !candidate?.adminNotes ? <div className="text-base text-slate-medium" style={{ padding: '0.2rem' }}>Not Available</div> :
                                <table className="ant-table">
                                    <tbody>
                                        {candidate?.adminNotes?.map((note, i) => (
                                            <tr key={i}>
                                                <td className="attr-col" style={{ width: '30%' }}>
                                                    <div className="fw-bold">{note?.email}</div>
                                                    <div className="text-sm fw-normal text-muted">{formatDate(note?.createdAt)}</div>
                                                </td>
                                                <td>{note?.notes}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                        }



                    </div>
                </section>
            </div>
            <PersonalityDetails
                isOpen={personalityDetails?.isOpen}
                per={personalityDetails?.per}
                handleShowPersonality={handlePersonality}
            />
        </div>
    );
}

